<template>
  <div style="font-size:14px;">
    <p style="margin-bottom:10px !important;">内容公开</p>
    <v-switch v-model="thisPublicStatus" dense inset :label="thisPublicStatus ? '公开' : '未公开'" style="width:120px;"></v-switch>
  </div>

</template>

<script>
export default {
  name: "CreatePublicSwitch",
  props:["publicStatus"],
  data(){
    return{

      thisPublicStatus:"",

    }

  },
  watch:{
    publicStatus(){
      this.thisPublicStatus = this.publicStatus;
    },
    thisPublicStatus(){
      this.$emit("changePublicStatus",this.thisPublicStatus)
    }
  },
  mounted(){
    this.thisPublicStatus = this.publicStatus;
  }

}
</script>

<style scoped>

</style>